<template>
  <GlassCard class="col-lg-2 mb-5 py-3">
    <div class="col-sm-12 col-md-12 h-100 m-0 p-0">
      <section>
        <div class="col-sm-12 col-md-12 form-group pt-3 mt-2">
          <p
            class="text-center"
            style="font-size: 1rem; line-height: 24px"
            :style="template.secondaryTheme ? 'color:white;' : ''"
          >
            Cadastro de Responsável Legal
          </p>
        </div>

        <div
          v-if="!showCreateGuardian && isGuardianCreated === null"
          style="margin: 40px 0; padding: 0 15px"
        >
          <p
            style="word-break: break-word; font-size: 12px"
            :style="template.secondaryTheme ? 'color:white;' : ''"
          >
            Para garantir a segurança, menores de 16 anos precisam cadastrar um responsável legal.
          </p>
          <p
            style="word-break: break-word; font-size: 12px"
            :style="template.secondaryTheme ? 'color:white;' : ''"
          >
            Para poder continuar com seu login, por favor, efetue o cadastro do seu responsável.
          </p>
        </div>
      </section>

      <transition name="cardSlide" mode="out-in" tag="div">
        <component
          v-if="showCreateGuardian && !guardianCreationFinished"
          style="margin: 40px 0"
          :is="activeComponent"
          @component="activeComponent = $event"
          :validate="callForValidation"
          @validating="callForValidation = false"
        />

        <!-- Loading Screen -->
        <div v-if="guardianCreationFinished">
          <div class="text-center" v-if="registrationErrors.length < 1">
            <LoadingRing />

            <p :style="template.secondaryTheme ? 'color: white;' : ''">
              {{ translation.waitRegisteringYourAccount }}
            </p>
          </div>
        </div>
      </transition>

      <div v-if="isGuardianCreated !== null" class="col-sm-12 col-md-12 form-group">
        <p
          style="word-break: break-word; font-size: 12px; margin: 40px 0"
          :style="template.secondaryTheme ? 'color:white;' : ''"
        >
          {{ guardianCreatedMessage }}
          <span v-if="isGuardianCreated === false">
            <br />
            Verifique seus dados, e tente cadastrar novamente.
          </span>
          <span v-if="isGuardianCreated === true">
            <br />
            Volte e faça o login novamente.
          </span>
        </p>
        <button
          v-if="isGuardianCreated === false"
          class="btn btn-block shadow-sm btnStock btn"
          :style="primaryBtnStyle"
          type="submit"
          @click="verifyGuardianData()"
        >
          Voltar
        </button>
        <button
          class="btn btn-block shadow-sm btnStock btn mt-3"
          :style="template.secondaryTheme ? secondaryBtnStyleTheme : secondaryBtnStyle"
          @click="$router.push(goToHomePage)"
        >
          <i class="fa fa-caret-left" />
          {{ isGuardianCreated === true ? 'Fazer login' : 'Voltar para o login' }}
        </button>
      </div>

      <!-- Success/Error Messages -->
      <div v-if="registrationErrors.length">
        <div class="errorsDiv" color="#ffffff">
          <span
            v-for="(error, i) in registrationErrors"
            :key="i"
            :style="ownerId == 23 ? 'color: #fcff45;' : 'color: #fff;'"
            style="font-size: 11px; letter-spacing: 0.35px"
          >
            *{{ error.msg }}
          </span>
        </div>
      </div>

      <div v-if="isGuardianCreated === null" class="col-sm-12 col-md-12 form-group mt-2 pt-3">
        <button
          v-if="!showCreateGuardian"
          class="btn btn-block shadow-sm btnStock btn"
          :style="primaryBtnStyle"
          type="submit"
          @click="showCreateGuardian = true"
        >
          Cadastrar agora
        </button>
        <button
          v-if="showCreateGuardian"
          class="btn btn-block shadow-sm btnStock btn"
          :style="primaryBtnStyle"
          type="submit"
          @click="callForValidation = true"
        >
          {{ showInputCheckEmailGuardian ? 'Finalizar cadastro' : 'Avançar' }}
        </button>
        <button
          class="btn btn-block shadow-sm btnStock btn mt-3"
          :style="template.secondaryTheme ? secondaryBtnStyleTheme : secondaryBtnStyle"
          @click="!showCreateGuardian ? $router.push(goToHomePage) : handleShowGuardianComponent()"
        >
          <i class="fa fa-caret-left" />

          Voltar
        </button>
      </div>
    </div>
  </GlassCard>
</template>

<script>
import Guardian from '@/components/cadastro/Guardian.vue'
import { mapState, mapGetters, mapMutations } from 'vuex'
import { getSSORedirectUrl } from '@/helpers/ssoHelper'
import { loginFB } from '../services/ServFB.js'
const lFB = new loginFB()

export default {
  name: 'CreateGuardian',
  components: {
    Guardian,
  },
  data: () => ({
    obj: {},
    callForValidation: false,
    activeComponent: 'Guardian',
    toastMessage: '',
    isGuardianCreated: null,
    guardianCreatedMessage: '',
    showCreateGuardian: false,
  }),
  computed: {
    ...mapGetters(['primaryBtnStyle', 'secondaryBtnStyle', 'secondaryBtnStyleTheme']),
    ...mapState([
      'template',
      'config',
      'subdomain',
      'showInputCheckEmailGuardian',
      'registrationErrors',
      'registrationObject',
      'countries',
      'guardianCreationFinished',
      'copyLoginPayload',
    ]),
    goToHomePage() {
      return getSSORedirectUrl(this.config)
    },
    ownerId() {
      return this.config.ownerId
    },
    translation() {
      if (this.countries.length) {
        return {
          accountCreationMessageNetworkError: 'Network error: please check your connection.',
          waitRegisteringYourAccount:
            'Please wait, we are registering your account. This may take a few seconds.',
        }
      }
      return {
        accountCreationMessageNetworkError: 'Erro de rede: Verifique sua conexão com a internet.',
        waitRegisteringYourAccount:
          'Aguarde, estamos atualizando o seu cadastro. Isso poderá levar alguns segundos.',
      }
    },
  },
  watch: {
    guardianCreationFinished(newVal) {
      if (newVal) {
        this.handleCreateGuardian()
      }
    },
  },
  mounted() {
    if (this.copyLoginPayload) {
      this.resetStepStates()
      this.resetRegistrationObject()
      this.clearRegistrationErrors()
    } else {
      this.$router.push(this.goToHomePage)
    }
  },
  methods: {
    ...mapMutations([
      'setShowInputCheckEmailGuardian',
      'setGuardianCreationFinished',
      'resetRegistrationObject',
      'clearRegistrationErrors',
      'addRegistrationError',
    ]),
    resetStepStates() {
      this.showCreateGuardian = false
      this.setShowInputCheckEmailGuardian(false)
      this.setGuardianCreationFinished(false)
    },
    makeToast(variant = null, title) {
      this.$bvToast.toast(this.toastMessage, {
        title: title,
        variant: variant,
        solid: true,
      })
    },
    handleShowGuardianComponent() {
      if (this.showInputCheckEmailGuardian) {
        this.setShowInputCheckEmailGuardian(false)
      } else {
        this.showCreateGuardian = false
      }
      this.clearRegistrationErrors()
    },
    verifyGuardianData() {
      this.clearRegistrationErrors()
      this.showCreateGuardian = true
      this.setShowInputCheckEmailGuardian(false)
      this.setGuardianCreationFinished(false)
      this.isGuardianCreated = null
    },
    async handleCreateGuardian() {
      let dataGuardianRegister = {
        login: this.copyLoginPayload.id,
        ownerId: this.copyLoginPayload.ownerId,
        sysId: this.copyLoginPayload.systemId,
        guardian: this.registrationObject.guardian,
      }

      try {
        const res = await lFB.createGuardian(dataGuardianRegister)
        this.toastMessage = res
        this.guardianCreatedMessage = res
        this.makeToast('light ', 'Sucesso')
        this.resetStepStates()
        this.isGuardianCreated = true
      } catch (err) {
        const errorMsg = `Erro ao cadastrar: ${err}`
        this.guardianCreatedMessage = errorMsg
        this.toastMessage = errorMsg
        this.makeToast('danger', 'Erro')
        this.resetStepStates()
        this.isGuardianCreated = false
      }
    },
  },
}
</script>

<style>
.cardSlide-enter-active {
  animation: slide-in 0.2s;
}

.cardSlide-leave-active {
  animation: slide-in 0.2s reverse;
}

@keyframes slide-in {
  0% {
    transform: translateX(10%);
    opacity: 0;
  }

  100% {
    transform: translateX(0%);
    opacity: 1;
  }
}
.errorsDiv {
  display: flex;
  flex-direction: column;
  margin: 40px 0;
  padding: 0 15px;
}
</style>
